import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/api/profile.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'auth-verify-ip-address',
  templateUrl: './verify-ip-address.component.html',
  styleUrls: ['./verify-ip-address.component.scss']
})
export class VerifyIpAddressComponent implements OnInit {

  loading = true;
  error: string = null;

  email: string;
  token: string;

  constructor(
    private profileService: ProfileService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.email = this.route.snapshot.queryParamMap.get('email');
    this.token = this.route.snapshot.queryParamMap.get('token');

    this.profileService.verifyIp(this.email, this.token).subscribe(response => {
      this.router.navigate(['/login']);
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

}
